import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { PromptDialogConfig } from './prompt-dialog.interfaces'
import { SaveForm } from '../../decorators'

@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss'],
  host: { class: 'modal-content' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PromptDialogComponent implements OnInit {
  config = {
    title: $localize`Prompt`,
    help: '',
    buttonText: $localize`Ok`,
    buttonIcon: 'cs-icon cs-icon-save',
    placeholder: '',
    titleIcon: '',
  } as PromptDialogConfig

  form = this.fb.group({
    value: [undefined, [Validators.required]],
  })

  constructor(
    public dialogRef: MatDialogRef<PromptDialogComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: PromptDialogConfig
  ) {}

  ngOnInit() {
    this.config = { ...this.config, ...this.data }
    this.form.patchValue({ value: this.data.defaultValue })
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  save(form: UntypedFormGroup) {
    const formValues = form.getRawValue()
    this.dialogRef.close(formValues.value)
  }
}
